export enum LoanStatus {
  NotAssigned = 0,
  Disclosed = 1,
  CreditOnly = 2,
  FileReceived = 3,
  UwReceived = 4,
  Approved = 5,
  Resubmitted = 6,
  Declined = 7,
  DocsOrdered = 8,
  DocsBack = 63,
  CancelForIncompleteness = 10,
  Prospect = 11,
  Suspended = 12,
  DocsSigned = 13,
  Funded = 14,
  Purchased = 15,
  ClearToClose = 16,
  DocsOut = 17,
  CollateralSent = 18,
  Shipped = 19,
  Registered = 51,
  CustomStatus2 = 52,
  AdvanceLock = 53,
  FundsOrdered = 54,
  PreApproved = 55,
  LePending = 56,
  PostClosingCompleted = 57,
  InvestorPurchased = 58,
  ApprovedNotAccepted = 59,
  Withdrawn = 60,
  ConditionForReview = 61,
  CustumStatus12 = 62,
  // CustomStatus13 = 63, See DocsBack above
  CustomStatus14 = 64,
  LoanRestructureAKACustomStatus15 = 65,
  CustomStatus16 = 66,
  CustomStatus17 = 67,
  CustomStatus18 = 68,
  CustomStatus19 = 69,
  CustomStatus20 = 70,
  CustomStatus21 = 71,
  CustomStatus22 = 72,
  CustomStatus23 = 73,
  CustomStatus24 = 74,
  CustomStatus25 = 75,
  Sandbox = 76, // Sandbox Loan Status (previously CustomStatus26)
  CustomStatus27 = 77,
  CustomStatus28 = 78,
  CustomStatus29 = 79,
  CustomStatus30 = 80,
}

/**
 * [Rate Lock] = LockStartDate exist and (No Expiration Date or Expiration Date is Greater/equal than current Date).
 * [NotAssigned] = Both the LockStartDate and LockEndDate are null.
 */
export enum LockStatusType {
  CanceledOrWithdrawn = 0,
  Expired = 1,
  Locked = 2,
  ModificationRequested = 3,
  Modified = 4,
  NotAssigned = 5,
  Other = 6,
  Pending = 7,
  Rejected = 8,
  Requested = 9,
}

export enum QuickActionDropdownType {
  EmailBorrowers = 'Email Borrowers',
  Scratchpad = 'Scratchpad',
  UploadDocs = 'Upload Docs',
  AUS = 'AUS',
  Disclosures = 'Disclosures',
  Parties = 'Parties',
  CondoProcessing = 'Condo Processing',
  GenerateAndDownloadDocuments = 'Generate and Download Documents',
  AUSRunsSandbox = 'AUS Run in Sandbox',
}

export enum Cmg1003Api {
  Save1003 = 'save1003',
  AutoRecoverySave1003 = 'autoRecoverySave1003',
  AutoRecoveryDelete1003 = 'AutoRecoveryDelete1003',
  GetLoanNotes = 'getLoanNotes',
  SaveLoanNotes = 'saveLoanNotes',
  SaveLoanApplicationNotes = 'saveLoanApplicationNotes',
}

export const LoanStatusTextMap = new Map<LoanStatus, string>([
  [LoanStatus.NotAssigned, 'Not Assigned'],
  [LoanStatus.Disclosed, 'Disclosed'],
  [LoanStatus.CreditOnly, 'Credit Only'],
  [LoanStatus.FileReceived, 'File Received'],
  [LoanStatus.UwReceived, 'UW Received'],
  [LoanStatus.PreApproved, 'PreApproved'],
  [LoanStatus.Approved, 'Approved'],
  [LoanStatus.Resubmitted, 'Resubmitted'],
  [LoanStatus.Declined, 'Declined'],
  [LoanStatus.DocsOrdered, 'Docs Ordered'],
  [LoanStatus.DocsBack, 'Docs Back'],
  [LoanStatus.CancelForIncompleteness, 'Cancel For Incompleteness'],
  [LoanStatus.Prospect, 'Prospect'],
  [LoanStatus.Suspended, 'Suspended'],
  [LoanStatus.DocsSigned, 'Docs Signed'],
  [LoanStatus.Funded, 'Funded'],
  [LoanStatus.Purchased, 'Purchased'],
  [LoanStatus.ClearToClose, 'Clear To Close'],
  [LoanStatus.DocsOut, 'Docs Out'],
  [LoanStatus.CollateralSent, 'Collateral Sent'],
  [LoanStatus.Shipped, 'Shipped'],
  [LoanStatus.Registered, 'Registered'],
  [LoanStatus.CustomStatus2, 'Funds Sent'],
  [LoanStatus.AdvanceLock, 'Advance Lock'],
  [LoanStatus.FundsOrdered, 'Funds Ordered'],
  [LoanStatus.PreApproved, 'Pre-Approved'],
  [LoanStatus.LePending, 'LE Pending'],
  [LoanStatus.PostClosingCompleted, 'Post Closing Completed'],
  [LoanStatus.InvestorPurchased, 'Investor Purchased'],
  [LoanStatus.ApprovedNotAccepted, 'Approved Not Accepted'],
  [LoanStatus.Withdrawn, 'Withdrawn'],
  [LoanStatus.ConditionForReview, 'Condition For Review'],
  [LoanStatus.CustumStatus12, 'Custum Status 12'],
  // [LoanStatus.CustomStatus13, 'Custom Status 13'], See DocsBack above
  [LoanStatus.CustomStatus14, 'Changes to UW'],
  [LoanStatus.LoanRestructureAKACustomStatus15, 'Loan Restructure'],
  [LoanStatus.CustomStatus16, 'Custom Status 16'],
  [LoanStatus.CustomStatus17, 'Custom Status 17'],
  [LoanStatus.CustomStatus18, 'Custom Status 18'],
  [LoanStatus.CustomStatus19, 'Custom Status 19'],
  [LoanStatus.CustomStatus20, 'Custom Status 20'],
  [LoanStatus.CustomStatus21, 'Custom Status 21'],
  [LoanStatus.CustomStatus22, 'Custom Status 22'],
  [LoanStatus.CustomStatus23, 'Custom Status 23'],
  [LoanStatus.CustomStatus24, 'Custom Status 24'],
  [LoanStatus.CustomStatus25, 'Custom Status 25'],
  [LoanStatus.Sandbox, 'Sandbox'],
  [LoanStatus.CustomStatus27, 'Custom Status 27'],
  [LoanStatus.CustomStatus28, 'Custom Status 28'],
  [LoanStatus.CustomStatus29, 'Custom Status 29'],
  [LoanStatus.CustomStatus30, 'Custom Status 30'],
]);

export const LoanLockedStatuses = [LoanStatus.Approved];

export enum LOCompType {
  Select = 0,
  BorrowerPaid = 1,
  LenderPaid = 2,
}
